enum Mutations {
  SET_SHIFT_PRESETS = 'setShiftPresets',
  UPDATE_SHIFT_PRESETS = 'updateShiftPresets',
  DELETE_SHIFT_PRESETS = 'deleteShiftPresets',
  SET_SELECTED_SHIFT_PRESET_IDS = 'setSelectedShiftPresetIds',
}

export default Mutations;
